(function () {
  var root = document.querySelector('[data-aura-product]');
  if (!root) return;

  var form = root.querySelector('[data-aura-product-form]');
  if (!form) return;

  var variantInput = root.querySelector('[data-aura-variant-id]');
  var variantsNode = root.querySelector('[data-aura-variants-json]');
  var priceNode = root.querySelector('[data-aura-price]');
  var comparePriceNode = root.querySelector('[data-aura-compare-price]');
  var installmentsNode = root.querySelector('[data-aura-installments]');
  var submitButton = root.querySelector('[data-aura-submit]');
  var titleSelectionNode = root.querySelector('[data-aura-title-selection]');
  var productMediaNode = root.querySelector('[data-aura-product-media-json]');
  var variantGalleryNode = root.querySelector('[data-aura-variant-gallery-json]');
  var variants = [];
  var productMediaGallery = [];
  var variantGallery = {};

  if (variantsNode) {
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      variants = [];
    }
  }

  if (productMediaNode) {
    try {
      productMediaGallery = JSON.parse(productMediaNode.textContent);
    } catch (error) {
      productMediaGallery = [];
    }
  }

  if (variantGalleryNode) {
    try {
      variantGallery = JSON.parse(variantGalleryNode.textContent);
    } catch (error) {
      variantGallery = {};
    }
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (error) {
      return '$' + Math.round(cents / 100).toLocaleString('es-CL');
    }
  }

  function getInstallmentText(cents, count) {
    var installmentValue = Math.round(cents / count);
    return count + ' cuotas sin interés de ' + formatMoney(installmentValue);
  }

  function getInstallmentMarkup(cents, count) {
    var installmentValue = Math.round(cents / count);
    return count + ' cuotas sin interés de <strong>' + formatMoney(installmentValue) + '</strong>';
  }

  function updateInstallments(cents) {
    if (!installmentsNode) return;

    var count = Number(installmentsNode.getAttribute('data-installment-count') || 6);
    installmentsNode.innerHTML = getInstallmentMarkup(cents, count);
  }

  function getSelectedOptions() {
    var optionGroups = form.querySelectorAll('[data-aura-variant-option]');
    return Array.prototype.map.call(optionGroups, function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    });
  }

  function getSelectedPlanterLabel() {
    var selectedPlanter = form.querySelector('input[name="properties[Macetero elegido]"]:checked');
    return selectedPlanter ? selectedPlanter.value : 'Solo planta';
  }

  function getTitleSelectionLabel() {
    var planterLabel = getSelectedPlanterLabel();
    return planterLabel === 'Solo planta' ? 'Solo planta - Incluye macetero base' : 'Planta + ' + planterLabel;
  }

  function getSelectedPlanterPrice() {
    var selectedPlanter = form.querySelector('input[name="properties[Macetero elegido]"]:checked');
    if (!selectedPlanter) return 0;
    return Number(selectedPlanter.getAttribute('data-planter-price') || 0);
  }

  function getDisplayTotal(basePrice) {
    return Number(basePrice || 0) + getSelectedPlanterPrice();
  }

  function updatePlanterCardPrices() {
    var planterInputs = form.querySelectorAll('input[name="properties[Macetero elegido]"]');

    Array.prototype.forEach.call(planterInputs, function (input) {
      var card = input.closest('.aura-planter-card');
      var priceNode = card ? card.querySelector('[data-planter-price-regular]') : null;
      if (!priceNode) return;

      var regularPrice = priceNode.getAttribute('data-planter-price-regular') || priceNode.textContent;
      var discountPrice = priceNode.getAttribute('data-planter-price-discount');
      priceNode.textContent = input.checked && discountPrice ? discountPrice : regularPrice;
    });
  }
  
  function getCompareTotal(selectedVariant) {
    if (!selectedVariant || !selectedVariant.compare_at_price || selectedVariant.compare_at_price <= selectedVariant.price) {
      return null;
    }

    return Number(selectedVariant.compare_at_price) + getSelectedPlanterPrice();
  }

  function updateComparePrice(node, selectedVariant) {
    if (!node) return;

    var compareTotal = getCompareTotal(selectedVariant);
    if (!compareTotal) {
      node.hidden = true;
      node.textContent = '';
      return;
    }

    node.hidden = false;
    node.textContent = formatMoney(compareTotal);
  }
  
  function updateStickySummary(selectedVariant) {
    var stickyPrice = document.querySelector('[data-aura-sticky-price]');
    var stickyComparePrice = document.querySelector('[data-aura-sticky-compare-price]');
    var stickyOptions = document.querySelector('[data-aura-sticky-options]');
    var stickyMiniOptions = document.querySelector('[data-aura-sticky-mini-options]');
    var stickyInstallments = document.querySelector('[data-aura-sticky-installments]');
    var totalPrice = selectedVariant ? getDisplayTotal(selectedVariant.price) : getSelectedPlanterPrice();

    if (stickyPrice && selectedVariant) {
      stickyPrice.textContent = formatMoney(totalPrice);
    }

    updateComparePrice(stickyComparePrice, selectedVariant);

    if (stickyInstallments && selectedVariant) {
      var stickyInstallmentCount = Number(stickyInstallments.getAttribute('data-installment-count') || 6);
      stickyInstallments.innerHTML = getInstallmentMarkup(totalPrice, stickyInstallmentCount);
    }
    
    if (stickyOptions) {
      var selectedOptions = getSelectedOptions().filter(function (option) {
        return option && option !== 'Default Title';
      });
      selectedOptions.push(getSelectedPlanterLabel());
      stickyOptions.textContent = selectedOptions.join(' - ');

      if (stickyMiniOptions) {
        stickyMiniOptions.textContent = selectedOptions.join(' - ');
      }
    }

    if (titleSelectionNode) {
      titleSelectionNode.textContent = getTitleSelectionLabel();
    }
  }

  function updateVariant() {
    if (!variants.length || !variantInput) return;
    
    var selectedOptions = getSelectedOptions();
    var selectedVariant = variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });

    if (!selectedVariant) return;

    variantInput.value = selectedVariant.id;

    if (priceNode) {
      priceNode.textContent = formatMoney(getDisplayTotal(selectedVariant.price));
    }
    
    updateComparePrice(comparePriceNode, selectedVariant);

    updateInstallments(getDisplayTotal(selectedVariant.price));
    updateVariantGallery(selectedVariant.id);

    if (submitButton) {
      submitButton.disabled = !selectedVariant.available;
      submitButton.textContent = selectedVariant.available ? 'Agregar al carrito' : 'Agotado';
    }

    updateStickySummary(selectedVariant);

    document.dispatchEvent(
      new CustomEvent('aura:variant-change', {
        detail: {
          variant: selectedVariant
        }
      })
    );
  }
  
  form.addEventListener('change', function () {
    updatePlanterCardPrices();
    updateVariant();
    if (!variants.length) updateStickySummary(null);
    window.setTimeout(function () {
      if (variantInput && variantInput.value) {
        updateVariantGallery(variantInput.value);
      }
    }, 0);
  });

  updatePlanterCardPrices();

  var planterScroller = root.querySelector('[data-aura-planter-scroller]');
  var planterPrev = root.querySelector('[data-aura-planter-prev]');
  var planterNext = root.querySelector('[data-aura-planter-next]');

  function scrollPlanters(direction) {
    if (!planterScroller) return;

    var firstCard = planterScroller.querySelector('.aura-planter-card');
    var step = firstCard ? firstCard.offsetWidth + 10 : planterScroller.clientWidth / 2;
    planterScroller.scrollBy({
      left: step * direction,
      behavior: 'smooth'
    });
      }

  if (planterPrev) {
    planterPrev.addEventListener('click', function () {
      scrollPlanters(-1);
    });
  }

  if (planterNext) {
    planterNext.addEventListener('click', function () {
      scrollPlanters(1);
    });
  }

  document.addEventListener('click', function (event) {
    var stickySubmit = event.target.closest('[data-aura-sticky-submit]');
    if (!stickySubmit) return;

    if (submitButton) {
      submitButton.click();
          } else {
      form.requestSubmit();
    }
  });

  form.addEventListener('submit', function (event) {
    var selectedPlanter = form.querySelector('input[name="properties[Macetero elegido]"]:checked');
    var planterVariantId = selectedPlanter ? selectedPlanter.getAttribute('data-planter-variant-id') : '';

    event.preventDefault();
    if (!variantInput || !variantInput.value) return;

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? Number(quantityInput.value || 1) : 1;
    var productTitle = form.getAttribute('data-product-title') || document.title;
    var originalText = submitButton ? submitButton.textContent : 'Agregar al carrito';
    var items = [
      {
        id: Number(variantInput.value),
        quantity: quantity,
        properties: {
          'Macetero elegido': selectedPlanter ? selectedPlanter.value : 'Solo planta'
        }
              }
    ];

    if (planterVariantId) {
      items.push({
        id: Number(planterVariantId),
        quantity: quantity,
        properties: {
          'Complemento para': productTitle
        }
      });
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Redirigiendo...';
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart error');
        window.location.href = '/cart';
      })
      ["catch"](function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }
        window.alert('No pudimos iniciar la compra. Intenta nuevamente.');
      });
  });
  
  var modal = document.querySelector('[data-aura-zoom-modal]');
  var modalImage = document.querySelector('[data-aura-zoom-image]');
  var closeModal = document.querySelector('[data-aura-close-zoom]');

  function openZoom(src) {
    if (!modal || !modalImage || !src) return;
    modalImage.src = src;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeZoom() {
    if (!modal || !modalImage) return;
    modal.hidden = true;
    modalImage.src = '';
    document.documentElement.style.overflow = '';
  }
  
  Array.prototype.forEach.call(document.querySelectorAll('[data-aura-zoom]'), function (button) {
    button.addEventListener('click', function () {
      openZoom(button.getAttribute('data-aura-zoom'));
    });
  });

  if (closeModal) {
    closeModal.addEventListener('click', closeZoom);
  }

  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeZoom();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeZoom();
  });
  
  var desktopSwitcher = root.querySelector('[data-aura-desktop-switcher]');
  var desktopPanels = Array.prototype.slice.call(root.querySelectorAll('[data-aura-desktop-panel]'));
  var desktopDots = Array.prototype.slice.call(root.querySelectorAll('[data-aura-desktop-dot]'));

  function updateGalleryImage(slot, imageData) {
    if (!slot || !imageData || !imageData.src) return;

    var image = slot.querySelector('img');
    if (!image) return;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('src', imageData.src);
    if (imageData.alt) {
      image.setAttribute('alt', imageData.alt);
    }
    slot.setAttribute('data-aura-zoom', imageData.zoom || imageData.src);
  }
  
  function getHeightNumber(value) {
    var match = String(value || '').match(/\d+/);
    return match ? match[0] : '';
  }

  function normalizeMediaLabel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/cm/g, '')
      .replace(/[–—_]/g, '-');
  }

  function getSelectedHeightNumber() {
    var optionGroups = form.querySelectorAll('[data-aura-variant-option]');
    var fallback = '';
    
    for (var index = 0; index < optionGroups.length; index += 1) {
      var fieldset = optionGroups[index];
      var legend = fieldset.querySelector('legend');
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var value = checked ? checked.value : '';
      var height = getHeightNumber(value);

      if (!height) continue;
      if (!fallback) fallback = height;
      if (legend && normalizeMediaLabel(legend.textContent).indexOf('altura') !== -1) {
        return height;
      }
    }

    return fallback;
  }
  
  function getMediaPosition(label) {
    var normalized = normalizeMediaLabel(label);
    var numberMatch = normalized.match(/(?:^|-)(\d+)$/);
    return numberMatch ? Number(numberMatch[1]) : 99;
  }

  function getGalleryFromProductMedia() {
    var height = getSelectedHeightNumber();
    if (!height || !productMediaGallery.length) return [];

    return productMediaGallery
      .filter(function (media) {
        var label = normalizeMediaLabel(media.alt);
        return label === height || label.indexOf(height + '-') === 0 || label.indexOf('-' + height) !== -1 || label.indexOf(height) !== -1;
      })
      .sort(function (first, second) {
        return getMediaPosition(first.alt) - getMediaPosition(second.alt);
      })
      .slice(0, 4);
  }
  
  function getGalleryFromSelectedOption() {
    var selectedGalleryOption = root.querySelector('[data-aura-option-gallery-1]:checked, [data-aura-option-gallery-2]:checked, [data-aura-option-gallery-3]:checked, [data-aura-option-gallery-4]:checked');
    if (!selectedGalleryOption) return [];

    return [1, 2, 3, 4].map(function (index) {
      var src = selectedGalleryOption.getAttribute('data-aura-option-gallery-' + index);
      return src ? { src: src, zoom: src } : null;
    });
  }

  function getGalleryFromRenderedMetafields(variantId) {
    var source = root.querySelector('[data-aura-variant-gallery-source="' + variantId + '"]');
    if (!source) return [];

    return [0, 1, 2, 3].map(function (index) {
      var item = source.querySelector('[data-aura-gallery-source-index="' + index + '"]');
      var image = item ? item.querySelector('img') : null;
      var src = image ? image.getAttribute('src') : '';
      return src ? { src: src, zoom: src } : null;
    });
      }

  function getUsableGalleryImages(galleryImages) {
    return (galleryImages || []).filter(function (imageData) {
      return imageData && imageData.src;
    }).slice(0, 4);
  }

  function updateMobileGallery(galleryImages) {
    if (!track) return;

    var usableImages = getUsableGalleryImages(galleryImages);
    var slides = Array.prototype.slice.call(track.querySelectorAll('.aura-mobile-slide'));

    slides.forEach(function (slide, index) {
      var imageData = usableImages[index];
      var image = slide.querySelector('img');

      if (!imageData || !image) {
                slide.hidden = true;
        slide.style.display = 'none';
        return;
      }

      slide.hidden = false;
      slide.style.display = '';
      updateGalleryImage(slide, imageData);
    });

    dots.forEach(function (dot, index) {
      var isVisible = index < usableImages.length;
      dot.hidden = !isVisible;
      dot.style.display = isVisible ? '' : 'none';
      dot.classList.toggle('is-active', index === 0);
    });

    track.scrollLeft = 0;
    updateMobileState();
  }
   
  function updateVariantGallery(variantId) {
    var mediaGallery = getGalleryFromProductMedia();
    var renderedGallery = getGalleryFromRenderedMetafields(variantId);
    var galleryImages = mediaGallery.length ? mediaGallery : renderedGallery.length ? renderedGallery : variantGallery[String(variantId)] || getGalleryFromSelectedOption();
    var hasUsableImage = galleryImages.some(function (imageData) {
      return imageData && imageData.src;
    });

    if (!hasUsableImage) {
      galleryImages = getGalleryFromSelectedOption();
    }

    if (!galleryImages || !galleryImages.length) return;

    Array.prototype.forEach.call(root.querySelectorAll('.aura-product__desktop-grid [data-aura-gallery-image]'), function (slot) {
      var index = Number(slot.getAttribute('data-aura-gallery-image'));
      updateGalleryImage(slot, galleryImages[index]);
    });
    
    setDesktopGalleryImage(0);
    updateMobileGallery(galleryImages);
  }

  function setDesktopGalleryImage(index) {
    desktopPanels.forEach(function (panel, panelIndex) {
      panel.classList.toggle('is-active', panelIndex === index);
    });

    desktopDots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });

    if (desktopSwitcher && desktopPanels[index]) {
      desktopSwitcher.setAttribute('data-aura-zoom', desktopPanels[index].getAttribute('data-aura-zoom') || '');
    }
  }
  
  desktopDots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      setDesktopGalleryImage(Number(dot.getAttribute('data-aura-desktop-dot')) || 0);
    });
  });

  var track = root.querySelector('[data-aura-mobile-track]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('.aura-mobile-dots span'));
  var currentZoomButton = root.querySelector('[data-aura-current-zoom]');

  function updateMobileState() {
    if (!track) return;

    var visibleSlides = Array.prototype.filter.call(track.children, function (slide) {
      return !slide.hidden && slide.style.display !== 'none';
    });
    var index = Math.round(track.scrollLeft / track.clientWidth);

    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === Math.min(index, dots.length - 1));
    });
        
    var slide = visibleSlides[index] || visibleSlides[0];
    if (currentZoomButton && slide) {
      currentZoomButton.setAttribute('data-aura-zoom', slide.getAttribute('data-aura-zoom') || '');
    }
  }

  if (track) {
    track.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(updateMobileState);
      },
      { passive: true }
    );
    updateMobileState();
  }
  
  if (currentZoomButton) {
    currentZoomButton.addEventListener('click', function () {
      openZoom(currentZoomButton.getAttribute('data-aura-zoom'));
    });
  }

  function syncProductState() {
    updateVariant();
    if (!variants.length) updateStickySummary(null);
  }

  syncProductState();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProductState);
  } else {
    window.setTimeout(syncProductState, 0);
  }
})();
